import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { StyledSidebar } from 'assets/jss/sidebar-style';
import { ExitModal } from 'modules/user/components/profile/exit-modal';
import { NotificationBadge } from './notification-badge/badge';
import { logoutHandler } from 'utils/auth-utils';

// Icons
import profileInActiveIcon from 'assets/img/bottomNav/profile_inactive.svg';
import ProfileActiveIcon from 'assets/img/bottomNav/profile_active.svg';
import NotificationInActiveIcon from 'assets/img/bottomNav/notification_inactive.svg';
import NotificationActiveIcon from 'assets/img/bottomNav/notification_active.svg';
import DashboardActiveIcon from 'assets/img/bottomNav/home_active.svg';
import DashboardInActiveIcon from 'assets/img/bottomNav/home_inactive.svg';
import ListInActiveIcon from 'assets/img/bottomNav/list/list.svg';
import ListActiveIcon from 'assets/img/bottomNav/list/listActive.svg';
import FreesensLogo from 'assets/img/freesensHome.svg';
import FaqIcon from 'assets/img/faqIcon.svg';
import FaqActiveIcon from 'assets/img/faq-active.svg';
import SupportActiveIcon from 'assets/img/active-support.svg';
import SupportInActiveIcon from 'assets/img/crmcrm.svg';
import ExitIcon from 'assets/img/exit2.svg';

const TABS = [
  {
    pathname: '/app/home',
    label: 'Dashboard',
    inActiveIcon: DashboardInActiveIcon,
    activeIcon: DashboardActiveIcon
  },
  {
    pathname: '/app/list',
    label: 'Patient List',
    inActiveIcon: ListInActiveIcon,
    activeIcon: ListActiveIcon
  },
  {
    pathname: '/app/notification',
    label: 'Notification',
    inActiveIcon: NotificationInActiveIcon,
    activeIcon: NotificationActiveIcon,
    badge: <NotificationBadge />
  },
  {
    pathname: '/app/profile',
    label: 'Profile',
    inActiveIcon: profileInActiveIcon,
    activeIcon: ProfileActiveIcon
  },
  {
    pathname: '/app/faq',
    label: 'FAQ',
    inActiveIcon: FaqIcon,
    activeIcon: FaqActiveIcon
  },
  {
    pathname: '/app/support',
    label: 'Support',
    inActiveIcon: SupportInActiveIcon,
    activeIcon: SupportActiveIcon
  },
  {
    label: 'Exit',
    activeIcon: ExitIcon,
    action: logoutHandler
  }
];

const SidebarIcon = ({ item, isActive, hoveredItem }) => {
  const Icon =
    isActive || hoveredItem === item.label || !item.inActiveIcon
      ? item.activeIcon
      : item.inActiveIcon;

  return (
    <div
      style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
    >
      {item.badge && item.badge}
      <img src={Icon} alt={item.label} />
    </div>
  );
};

export const Sidebar = () => {
  const { pathname } = useLocation();
  const shouldExpand = !['/app/report', '/app/edit'].includes(pathname);

  const [expanded, setExpanded] = useState(shouldExpand);
  const [hoveredItem, setHoveredItem] = useState('');

  useEffect(() => {
    setExpanded(shouldExpand);
  }, [shouldExpand]);

  const handleMouseOverItem = (item) => setHoveredItem(item.label);
  const handleMouseLeaveItem = () => setHoveredItem('');

  const handleMouseOverList = () => {
    if (!shouldExpand) setExpanded(true);
  };

  const handleMouseLeaveList = () => {
    if (!shouldExpand) setExpanded(false);
  };

  const renderTab = (item) => {
    const isActive = item.pathname === pathname;
    const listItem = (
      <li
        key={item.label}
        onMouseOver={() => handleMouseOverItem(item)}
        onMouseLeave={handleMouseLeaveItem}
      >
        <div className={isActive ? 'li-border' : ''} />
        <div
          style={{ padding: isActive ? '0 13px' : '' }}
          className={`li-content ${isActive ? 'li-isActive' : ''}`}
        >
          <SidebarIcon
            item={item}
            isActive={isActive}
            hoveredItem={hoveredItem}
          />
          <span>{item.label}</span>
        </div>
      </li>
    );

    if (item.label === 'Exit') {
      return <ExitModal logout={item.action}>{listItem}</ExitModal>;
    }

    return (
      <NavLink to={item.pathname}>
        {listItem}
        {item.label === 'Profile' && <div className="li-divider" />}
      </NavLink>
    );
  };

  return (
    <StyledSidebar isExpanded={expanded}>
      <div className="sidebar-container">
        <img
          src={FreesensLogo}
          alt="Freesens Logo"
          className="side-freesens-logo"
        />
        <ul
          onMouseOver={handleMouseOverList}
          onMouseLeave={handleMouseLeaveList}
        >
          {TABS.map(renderTab)}
        </ul>
      </div>
    </StyledSidebar>
  );
};
